// extracted by mini-css-extract-plugin
export default {"overlay":"taskGrid_overlay__-+Y8T","container":"taskGrid_container__6EU-Z","text":"taskGrid_text__ntfSl","card":"taskGrid_card__L69+r"};